//User mnagement
import Login from '@/components/UserManagement/Log-in/LogIn.vue';
import Register from '@/components/UserManagement/Register/register.vue';
import Forgotpassword from '@/components/UserManagement/Log-in/Forgot-ps.vue';
//Password reset and change compoenent
import PasswordChange from '@/components/UserManagement/PasswordChange.vue';

//Layout
import userHeader from '@/components/Layout/User_header.vue';
import PageFooter from '@/components/Layout/PageFooter.vue';
import logo from '@/components/Layout/Logo.vue';
import Home from '@/components/HomePage/Home.vue';

//Menu

//withdraw
import Withdraw from '@/components/Withdrawal/Withdraw.vue';
import Banklists from '@/components/Withdrawal/Banklist.vue';
import Addbank from '@/components/Withdrawal/AddBank.vue';

//history
// import History from '@/components/History/History.vue';
import DepositTicket from '@/components/History/DepositTicket.vue';
import WithdrawTicket from '@/components/History/WithdrawTicket.vue';
import TransferTicket from '@/components/History/TransferTicket.vue';

//promotion
import Promotion from '@/components/Promotions/Promotion.vue';

//affiliate
import Affiliate from '@/components/Affiliate/Affiliate.vue';

//game
import Game from '@/components/Games/Game.vue';

//deposit
import Deposit from '@/components/Deposit/Deposit.vue';

//transfer
import Transfer from '@/components/Transfer/Transfer.vue';

//Contact
import Contact from '@/components/Contact/Contact.vue';

//HowTo
import Tips from '@/components/HowTo/Tips.vue';
import Play from '@/components/HowTo/Play.vue';

//Download Link
import Download from '@/components/Download/Download.vue';

//Mini Game
import MiniGame from '@/components/MiniGame/MiniGame.vue';
import MiniGamePrizes from '@/components/MiniGame/MiniGamePrizes.vue';


//404
import NotFound from '@/components/NotFound.vue';

//Coming Soon
import ComingSoon from '@/components/ComingSoon.vue';

//vuex
import { store } from './store';

export const routes = [
    {
        path: '/',
        name: 'home',
        alias: '/home',
        components: {
            default: Home,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/login',
        name: 'login',
        components: {
            default: Login,
            logo: logo,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/register',
        name: 'Register',
        components: {
            default: Register,
            logo: logo,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/forgotpassword',
        name: 'Forgot Password',
        components: {
            default: Forgotpassword,
            logo: logo,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/passwordchange',
        name: 'Change Password',
        components: {
            default: PasswordChange,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/passwordreset',
        name: 'Password Reset',
        components: {
            default: PasswordChange,
            headertop: userHeader,
            logo: logo,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        }
    },

    {
        path: '/DepositTicket',
        name: 'History / Deposit',
        components: {
            default: DepositTicket,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/WithdrawTicket',
        name: 'History / Withdraw',
        components: {
            default: WithdrawTicket,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/TransferTicket',
        name: 'History / Transfer',
        components: {
            default: TransferTicket,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        }
    },

    {
        path: '/promotion',
        name: 'Promotion',
        components: {
            default: Promotion,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/affiliate',
        name: 'Affiliate',
        components: {
            default: Affiliate,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/game',
        name: 'Game',
        props: {
            default:true,
            headertop: false,
            footer: false
        },
        components: {
            default: Game,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/withdraw',
        name: 'Withdraw',
        components: {
            default: Withdraw,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        },
        children: [
            {
                path: '',
                name: 'Banklist',
                components: {
                    default: Banklists,
                    headertop: userHeader,
                    footer: PageFooter
                }
            },
            {
                path: 'addbank',
                name: 'Addbank',
                components: {
                    default: Addbank,
                    headertop: userHeader,
                    footer: PageFooter
                }
            }
        ]
    },
    {
        path: '/deposit',
        name: 'Deposit',
        components: {
            default: Deposit,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/transfer',
        name: 'Transfer',
        components: {
            default: Transfer,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/contact',
        name: 'Contact',
        components: {
            default: Contact,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/tips',
        name: 'Tips',
        components: {
            default: Tips,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/play',
        name: 'Play',
        components: {
            default: Play,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/download',
        name: "Download Link",
        components: {
            default: Download,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/miniGame',
        name: "Mini Game",
        components: {
            default: MiniGame,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        },
        beforeEnter: (to, from, next) => {

            if (store.getters.services && store.getters.services['mini_game_service'] == 0) {
                next({ name: 'Coming Soon' });
            } else {
                next();
            }
          }
    },
    {
        path: '/miniGamePrizes',
        name: "Mini Game Prizes",
        components: {
            default: MiniGamePrizes,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        },
        beforeEnter: (to, from, next) => {

            if (store.getters.services && store.getters.services['mini_game_service'] == 0) {
                next({ name: 'Coming Soon' });
            } else {
                next();
            }
          }
    },
    {
        path: '/coming-soon',
        name: "Coming Soon",
        components: {
            default: ComingSoon,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        }
    },
    {
        path: '*',
        name: "404 Not Found",
        components: {
            default: NotFound,
            headertop: userHeader,
            footer: PageFooter
        },
        meta: {
            keepAlive: false
        },
    },
];